import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Grid, MenuItem, TextField } from "@mui/material";
import { t } from "i18next";
import { useState } from "react";
import TaskCalendar from "../../components/calendar/Calendar";
import DefaultPageWrapper from "../../components/wrapper/DefaultPageWrapper";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import useUserId from "../../hooks/useUserId";
import { useGetSellers } from "../../services/usersApi";
import { CreateTaskDialog } from "./CreateTaskDialog";
import { TodoTasksSidebar } from "./TodoTasksSidebar";

function SellerSelect({ sellerUserId, onSellerChange }) {
    const { data: sellers } = useGetSellers();

    return (
        <TextField
            select
            label={t("tasks.calendar.sellerDropdownTitle")}
            value={sellerUserId || ""}
            onChange={(e) => onSellerChange(e.target.value)}
            fullWidth
            size="small"
        >
            {sellers?.map((seller) => (
                <MenuItem key={seller.user_id} value={seller.user_id}>
                    {seller.full_name}
                </MenuItem>
            ))}
        </TextField>
    );
}

function TaskWaySelect({ taskWay, onWayChange }) {
    const ways = ["PHONE", "EMAIL", "MEETING", "ALL"];

    return (
        <TextField
            select
            label={t("tasks.calendar.wayDropdownTitle")}
            value={taskWay || "ALL"}
            onChange={(e) => onWayChange(e.target.value)}
            fullWidth
            size="small"
        >
            {ways?.map((way) => {
                return (
                    <MenuItem key={way} value={way}>
                        {t(`tasks.ways.${way}`)}
                    </MenuItem>
                );
            })}
        </TextField>
    );
}

export function TaskPage() {
    const userId = useUserId();
    const [sellerUserId, setSellerUserId] = useState(userId);
    const [taskWay, setTaskWay] = useState(null);
    const { openDialog, closeDialog } = useDialogBetter();

    return (
        <DefaultPageWrapper tagTitle={t("headers.tasks")} titleKey="tasks">
            <Box sx={{ position: "relative", height: "100%", overflow: "hidden" }}>
                    <Grid
                        container
                        spacing={5}
                        justifyContent="center"
                        alignItems="center"
                        sx={{ mt: 1 }}
                    >
                        <Grid item sx={{ mr: 3 }}>
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<AddIcon />}
                                onClick={() =>
                                    openDialog({
                                        Component: CreateTaskDialog,
                                        componentProps: {
                                            defaultSellerId: sellerUserId || undefined,
                                        },
                                        onCloseFn: () => {
                                            closeDialog();
                                        },
                                    })
                                }
                            >
                                {t("tasks.addTask")}
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            <SellerSelect
                                sellerUserId={sellerUserId}
                                onSellerChange={(id) => {
                                    setSellerUserId(id);
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TaskWaySelect
                                taskWay={taskWay}
                                onWayChange={(id) => {
                                    setTaskWay(id);
                                }}
                            />
                        </Grid>
                    </Grid>
                <Box sx={{ width: "100%", height: "100vh", overflow: "hidden" }}>
                    <TaskCalendar sellerUserId={sellerUserId} taskWay={taskWay} />
                </Box>

                <TodoTasksSidebar userId={userId || ""} />
            </Box>
        </DefaultPageWrapper>
    );
}
